import $fn from "@/utils/fn.ts";
import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

// 获取提现配置
interface ExtractConfigInfoData {
  token: string;
}

export const extractConfigInfo = (json: ExtractConfigInfoData): any =>
  http.httpPost({
    url: httpApi.moneyTx.extractConfigInfo,
    json,
  });

// 提现配置
interface ExtractConfigData {
  id: string;
  type: number;
  account_time?: string;
  min_extract_money: string;
  min_extarct_ratio: string;
  min_extarct_charge: string;
  close_money_pay: number;
  close_money_extract: number;
  explain: string;
  normal_explain?: string;
  speed_up_explain?: string;
}

export const extractConfig = (json: ExtractConfigData): any =>
  http.httpPost({
    url: httpApi.moneyTx.extractConfig,
    json,
  });

// 待运营审核列表
interface ExtractApplyListData {
  type: number;
  page: number;
  pagenum: number;
}

export const extractApplyList = (json: ExtractApplyListData): any =>
  http.httpPost({
    url: httpApi.moneyTx.extractApplyList,
    json,
  });

// 运营审核
interface AuditExtractData {
  type: number;
  id_arr: any;
  tips: string;
}

export const auditExtract = (json: AuditExtractData): any =>
  http.httpPost({
    url: httpApi.moneyTx.auditExtract,
    json,
  });

// 运营审核全部同意
interface YyAuditAllData {
  token: string;
}

export const YyAuditAll = (json: YyAuditAllData): any =>
  http.httpPost({
    url: httpApi.moneyTx.YyAuditAll,
    json,
  });

// 待财务审核1列表
interface CwAuditListData {
  type: number;
  page: number;
  pagenum: number;
}

export const cwAuditList = (json: CwAuditListData): any =>
  http.httpPost({
    url: httpApi.moneyTx.cwAuditList,
    json,
  });

// 财务审核1

export const cwAudit = (json: AuditExtractData): any =>
  http.httpPost({
    url: httpApi.moneyTx.cwAudit,
    json,
  });

// 财务审核1全部同意
interface Cw1AuditAllData {
  token: string;
}

export const Cw1AuditAll = (json: Cw1AuditAllData): any =>
  http.httpPost({
    url: httpApi.moneyTx.Cw1AuditAll,
    json,
  });

// 待财务审核2列表
interface WaitPaymentListtData {
  type: number;
  page: number;
  pagenum: number;
}

export const waitPaymentList = (json: WaitPaymentListtData): any =>
  http.httpPost({
    url: httpApi.moneyTx.waitPaymentList,
    json,
  });

// 财务审核2
export const paymemt = (json: AuditExtractData): any =>
  http.httpPost({
    url: httpApi.moneyTx.paymemt,
    json,
  });

// 财务审核2全部同意
interface PaymemtAllData {
  type: number;
}
export const paymemtAll = (json: PaymemtAllData): any =>
  http.httpPost({
    url: httpApi.moneyTx.paymemtAll,
    json,
  });

// 审核记录
interface ExtractListData {
  type: number;
  order_id: string;
  account: string;
  alipay_account: string;
  stime: string;
  etime: string;
  payment_start_time: string;
  payment_end_time: string;
  id: string;
  uid: string;
  page: number;
  pagenum: number;
}

export const extractList = (json: ExtractListData): any =>
  http.httpPost({
    url: httpApi.moneyTx.extractList,
    json,
  });

// 提现进度查询
interface ExtractPlanData {
  token: string;
  type: number;
  page: number;
  pagenum: number;
  account: string;
  uid: number;
}

export const extractPlan = (json: ExtractPlanData): any =>
  http.httpPost({
    url: httpApi.moneyTx.extractPlan,
    json,
  });

// 交易记录excel导出
interface ExtractExcelData {
  token: string;
  stime: string;
  etime: string;
  status: string;
}

export const extractExcel = (json: ExtractExcelData): any =>
  http.httpGet({
    url: httpApi.moneyTx.extractExcel,
    json,
  });

// 溯源订单查看提现详情
interface GetExtractInfoData {
  id: string;
}

export const getExtractInfo = (json: GetExtractInfoData): any =>
  http.httpGet({
    url: httpApi.moneyTx.getExtractInfo,
    json,
  });
